import { getCmsPageData } from '@/apis/apiCms';
import { Home_Page_Code } from '@/constants/cms';
import { MiniHomeClient } from './MiniHomeClient';

export default async function MiniHome() {
  const pageData = await getCmsPageData(Home_Page_Code);
  const floors = pageData?.data?.floors || [];
  const moduleData = floors
    .flatMap((floor) => floor.moduleInstances || [])
    .find((instance) => instance.moduleCode === 'uk-miniHome');

  const List = moduleData?.dataBatch?.tabList ?? [];

  return <MiniHomeClient homeList={List} />;
}
